import { createConsumer } from "@rails/actioncable"

export type CableConsumer = ReturnType<typeof createConsumer>

export type CableSubscriptionCallbacks = {
  connected?: () => void
  disconnected?: () => void
  rejected?: () => void
  received?: (data: unknown) => void
}

let consumer: CableConsumer | null = null

/** One WebSocket per tab. Channels subscribe on this consumer; do not disconnect() from a panel. */
export function getCableConsumer(): CableConsumer {
  if (!consumer) consumer = createConsumer()
  return consumer
}

/**
 * Subscribe without racing Action Cable's confirm.
 * unsubscribe() before the server has the channel logs ERROR "Unable to find subscription".
 * Cleanup only unsubscribes after `connected`; if confirm arrives after cancel, unsubscribe then.
 */
export function subscribeCableChannel(
  cable: CableConsumer,
  params: Record<string, unknown>,
  callbacks: CableSubscriptionCallbacks,
): () => void {
  let cancelled = false
  let confirmed = false
  const subscription = cable.subscriptions.create(params, {
    connected() {
      if (cancelled) {
        subscription.unsubscribe()
        return
      }
      confirmed = true
      callbacks.connected?.()
    },
    disconnected() {
      confirmed = false
      if (!cancelled) callbacks.disconnected?.()
    },
    rejected() {
      confirmed = false
      if (!cancelled) callbacks.rejected?.()
    },
    received(data: unknown) {
      if (!cancelled) callbacks.received?.(data)
    },
  })

  return () => {
    cancelled = true
    if (!confirmed) return
    confirmed = false
    subscription.unsubscribe()
  }
}
